import React, { useState, useEffect } from 'react';
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';
import Switch from 'react-switch';
import TimezonePicker from 'react-bootstrap-timezone-picker';
// import "react-bootstrap-timezone-picker/dist/react-bootstrap-timezone-picker.min.css";
// COMPONENTS
import Header from '../../../components/header';
import BuyNow from '../../../components/buyNowSection';
import Carousel from '../../../components/carousel';
import Footer from '../../../components/footer';
// ICONS
import { FaArrowLeft } from 'react-icons/fa';
// STYLES
import '../styles.css';
import _ from 'lodash';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router';

const TimezoneSettings = () => {
  const history = useHistory();
  const alreadyLoggedIn = localStorage.getItem('token');
  if (!alreadyLoggedIn) {
    history.push('/');
  }
  const [check, setCheck] = useState(false);
  const [selectedTimezone, setSelectedTimezone] = useState('');
  const token = localStorage.getItem('token');
  const physicalId = localStorage.getItem('physicalId');
  const headers = {
    Accept: '*/*',
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + token,
  };
  const timeZoneFormatAPI = `control/${physicalId}/software/time-mode`;
  const timeZoneAPI = `control/${physicalId}/doptime/timezone`;

  useEffect(() => {
    fetch(timeZoneFormatAPI, {
      method: 'GET',
      headers: headers,
    })
      .then((response) => response.json())
      .then((response) => {
        if (response?.timeMode > 12) {
          setCheck(true);
        } else {
          setCheck(false);
        }
      })
      .catch((error) => console.log(error));
  }, []);

  const handleTimeZoneFormat = (check) => {
    setCheck(check);
    fetch(timeZoneFormatAPI, {
      method: 'PUT',
      headers: headers,
      body: JSON.stringify({
        timeMode: check === false ? 12 : 24,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        // setSelectedTimezone(response?.timeMode);
        toast.success('Format update!', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        });
      })
      .catch((error) => {
        toast.error('Format not update!', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        });
      });
  };

  useEffect(() => {
    fetch(timeZoneAPI, {
      method: 'GET',
      headers: headers,
    })
      .then((response) => response.json())
      .then((response) => {
        setSelectedTimezone(response?.timezone);
      })
      .catch((error) => console.log(error));
  }, []);

  const handleTimeZoneApi = (value) => {
    setSelectedTimezone(value);
    fetch(timeZoneAPI, {
      method: 'PUT',
      headers: headers,
      body: JSON.stringify({
        timezone: value,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        toast.success('Timezone update!', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        });
      })
      .catch((error) => {
        toast.success('Timezone not update!', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        });
      });
  };
  return (
    <div>
      <Header />
      <BuyNow />
      <Carousel />
      <section
        class='login-bg'
        style={{ backgroundImage: 'url(./images/login-bg.jpg)' }}
      >
        <div class='container'>
          <a href='/settings' class='back-arrow'>
            <FaArrowLeft />
          </a>
          <h2 class='text-left' style={{ textAlign: 'left' }}>
            SELECT TIMEZONE
          </h2>
          <div class='use-24'>
            <p>USE 24-HOUR FORMAT</p>
            <div class='custom-control custom-switch'>
              <Switch
                onChange={handleTimeZoneFormat}
                checked={check}
                checkedIcon={false}
                uncheckedIcon={false}
                offColor='#707070'
                onColor='#49c85a'
              />
              <label class='custom-control-label' for='customSwitch1'></label>
            </div>
          </div>
          <div
            style={{
              backgroundColor: 'transparent',
              width: '100%',
              height: 400,
              borderWidth: 1,
              overflow: 'scroll',
            }}
            className='scrollbar-hidden'
          >
            <TimezonePicker
              absolute={false}
              defaultValue={selectedTimezone}
              placeholder={
                selectedTimezone && selectedTimezone.length > 0
                  ? selectedTimezone
                  : 'Select timezone here'
              }
              onChange={handleTimeZoneApi}
              style={{
                backgroundColor: 'transparent',
                color: '#ffffff',
                width: '50%',
              }}
            />
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};
export default TimezoneSettings;
